var _require = require('ramda'),
  map = _require.map,
  filter = _require.filter,
  pipe = _require.pipe,
  flatten = _require.flatten,
  defaultTo = _require.defaultTo,
  isEmpty = _require.isEmpty;
var getJobSubCategories = function getJobSubCategories(meCategoryPreference) {
  return pipe(defaultTo([]), filter(function (_ref) {
    var value = _ref.value;
    return meCategoryPreference.includes(value);
  }), map(function (_ref2) {
    var subCategories = _ref2.subCategories;
    return subCategories.map(function (_ref3) {
      var value = _ref3.value;
      return value;
    });
  }), flatten);
};
var extractQueryParams = function extractQueryParams(meJobPreferences, categories) {
  var canSeePgaProJob = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!meJobPreferences || isEmpty(meJobPreferences)) return null;
  var minimumCompensation = meJobPreferences.minimumCompensation,
    openToSeasonal = meJobPreferences.openToSeasonal,
    jobLocations = meJobPreferences.jobLocations,
    meJobCategories = meJobPreferences.jobCategories;
  return {
    categories: getJobSubCategories(meJobCategories)(categories),
    salaryRange: {
      baseCompMin: minimumCompensation
    },
    locations: jobLocations.filter(function (v) {
      return v;
    }).map(function (state) {
      return {
        name: state,
        code: state
      };
    }),
    seasonal: openToSeasonal,
    excludeProOnly: !canSeePgaProJob
  };
};
module.exports = {
  extractQueryParams: extractQueryParams,
  getJobSubCategories: getJobSubCategories
};